var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element-container',{on:{"resized":function($event){_vm.width = $event.width}}},[_c('div',{staticClass:"publish-fields",class:{ 'publish-fields-narrow': _vm.width <= 600 }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }